import * as Components from './react-native/components';
import { renderToElement } from './react-native/render';

// utils
const pascalToKebab = (pascalCase) => pascalCase.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();

const registerWebComponent = ([name, reactComponent]) => {
    console.log('Registering', name);
    window.customElements.define(name, class extends HTMLElement {
        constructor() {
            super();
        }

        connectedCallback() {
            renderToElement(this, reactComponent);

            // Set up an observer for attribute changes
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    if (mutation.type === 'attributes') {
                        renderToElement(this, reactComponent);
                    }
                });
            });

            // Start observing attribute changes
            observer.observe(this, { attributes: true });
        }
    })
};

// Imported component names
const components = Object.keys(Components)
    .map(componentName => [pascalToKebab(componentName), Components[componentName]]);


components.forEach(registerWebComponent);
